import themeManifest from '../theme-manifest.json';

const primaryColor = themeManifest.colors.primary;

export {
  primaryColor,
};
